import BannerSimple from './BannerSimple'

export default BannerSimple
